<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Smart Number'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (isLoading) {
    } @else if (isGuestAccount) {
      <tidy-alert>
        <tidy-row>
          <tidy-text
            [body]="'Please complete your account signup to create a smart number.'" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-button
            [text]="'Complete Signup'"
            class="primary"
            (click)="openCompleteSignup()" />
        </tidy-row>
      </tidy-alert>
    } @else if (!hasValidCard) {
      <tidy-alert>
        <tidy-row>
          <tidy-text
            [body]="'Please add a credit card to create a smart number.'" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-button
            [text]="'Add Payment Method'"
            class="primary"
            (click)="goToAddPaymentMethod()" />
        </tidy-row>
      </tidy-alert>
    } @else {
      <tidy-card>
        <tidy-row class="vertical-align-center" [alignLastItemRight]="true">
          <tidy-text
            [header]="'Pro Smart Number'" />
          <tidy-toggle
            [toggled]="enableProSmartNumber"
            (toggleChanged)="enableProSmartNumber = !enableProSmartNumber" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text
            [body]="'1. Share this with pros who you want to be able to message in.'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'2. As pros message in, they come into your Messages section.'" />
        </tidy-row>
      </tidy-card>

      <tidy-card>
        <tidy-row class="vertical-align-center" [alignLastItemRight]="true">
          <tidy-text
            [header]="'Guest Smart Number'" />
          <tidy-toggle
            [toggled]="enableGuestSmartNumber"
            (toggleChanged)="enableGuestSmartNumber = !enableGuestSmartNumber" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text
            [body]="'1. Share this with guests, tenants, or anyone you want to be able message in.'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'2. As guests message in, they come into your Messages section.'" />
        </tidy-row>
      </tidy-card>

      <tidy-button
        [text]="'Save'"
        [action]="boundSave"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
